// import { useState, useEffect, useCallback } from 'react';

export interface IPaginationConfig{
  totalItemCount: number;
  pageSizes?: number[];
  currentPage?: number;
  currentPageSize?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextPageSize: number) => void;
}

export interface IPaginationConfig{
  readOnly: boolean;
  totalItemCount: number;
  colSpanLength: number;
  pageSizes?: number[];
  currentPage?: number;
  currentPageSize?: number;
  onChangePage: (nextPage: number) => void;
  onChangePageSize: (nextPageSize: number) => void;
}

export interface IBounds{
  left: boolean,
  right: boolean,
}

export interface IPagination{
  bounds: IBounds,
  startItemPos: number,
  endItemPos: number
}

export default function usePagination(config: IPaginationConfig): IPagination{
  const {
    totalItemCount,
    pageSizes = [10, 20, 50],
    currentPage = 0,
    currentPageSize = pageSizes[0],
  } = config;

  const pageCount = getPageCount(totalItemCount, currentPageSize)
  const bounds = {
    left: currentPage === 0,
    right:  currentPage + 1 === pageCount
  }
  return {
    bounds,
    startItemPos: (currentPage * currentPageSize + 1),
    endItemPos: Math.min(((currentPage + 1) * currentPageSize), totalItemCount)
  }
}

function getPageCount(itemCount: number, pageSize: number): number{
  const mod = itemCount % pageSize;
  const minPageSize = (itemCount - mod) / pageSize;
  const overflow = mod === 0 ? 0 : 1;
  return minPageSize + overflow;
}